module.exports = __webpack_public_path__ + "img/ziraat.6cbaaa08.jpg";